export default __webpack_public_path__ + "static/media/mockup_checkout.c77656da.png";